import { useState, useEffect, useRef } from 'react'
import i18next from '~/i18n'
import { motion } from 'framer-motion'
import { getStatusMessages } from '~/lib/api'
import * as styles from './index.module.css'

export default function StatusMessages() {

  const [messages, setMessages] = useState([])
  const statusRef = useRef(null);

  const getMessage = item => {
    return item?.messages[i18next.language]
  }

  useEffect(() => {
    getStatusMessages().then(response => {
      setMessages(Array.isArray(response) ? response : [])
      
      //let navHeight = Document.documentElement.style.setProperty('--nav-height', navHeightTest + 'px');

    })
    .catch(error => {
      console.error(error)
    })
  }, [])

  useEffect(() => {
    function handleResize() {
      setHeight();
    }
    window.addEventListener('resize', handleResize)

    return _ => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  const setHeight = () => {
    let barHeight = statusRef?.current?.offsetHeight || 0;
    document.documentElement.style.setProperty('--status-height', barHeight + "px");

    console.log("barHeight", barHeight); // Returns the nav height as a number
  }

  return (
    <>
      {messages.map(item => {
        return (
          <motion.div 
            ref={statusRef}
            key={item.id} 
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            className={styles.alertItem}
            onUpdate={setHeight}
          >
            <div className={styles.info}></div>
            <p>{getMessage(item)}</p>
          </motion.div>
        )
      })}
    </>
  )
}

